import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'ui-bank-search-intro-step',
  styleUrl: 'ui-bank-search-intro-step.scss',
  shadow: true,
})
export class UiBankSearchIntroStep {
  @Prop() icon: string;

  @Prop({ reflect: true }) big: boolean;

  render() {
    return (
      <Host>
        <div class="icon-container">
          <sd-icon
            library={(window as any).ui.cmsState?.iconLibrary}
            name={`union-investment/content/${this.icon}`}
          ></sd-icon>
        </div>
        <slot></slot>
      </Host>
    );
  }
}
